import { Flex } from 'reflexbox';
import styled from 'styled-components/macro';

const PageWrapper = styled(Flex)`
  height: 100vh;
`;

export default PageWrapper;
